import useAuthStore from 'store/auth';
import {
  getFamilyMemberAttributes,
  getMemberDetails,
} from 'services/profile/api';

export default function useUpdateProfile() {
  const setUserEmail = useAuthStore((store) => store.setUserEmail);
  const setUserAttributes = useAuthStore((store) => store.setUserAttributes);
  const setCurrentUserProfileId = useAuthStore(
    (store) => store.setCurrentUserProfileId
  );
  const setMemberDetails = useAuthStore((store) => store.setMemberDetails);

  const onUpdateMemberDetails = async () => {
    try {
      const memberDetails = await getMemberDetails();
      if (memberDetails && memberDetails?.length) {
        setMemberDetails(memberDetails);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onUpdateUserAttributes = async (profile_id: string) => {
    if (!profile_id) return;

    try {
      const attributes = await getFamilyMemberAttributes({
        profile_id,
      });
      if (attributes) {
        setUserAttributes(attributes);
        setCurrentUserProfileId(profile_id);
        setUserEmail(attributes.email!);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onUpdateProfile = async (profile_id: string) => {
    if (!profile_id) return;

    try {
      await onUpdateUserAttributes(profile_id);
    } catch (error) {
      console.error(error);
    }
  };

  return { onUpdateProfile, onUpdateMemberDetails, onUpdateUserAttributes };
}
